import { Mods, classNames } from '@lib/classNames/classNames';
import Link from 'next/link';
import React from 'react';

import { ButtonProps, ButtonSpacing } from './types';

const SPACING_CONFIG: Record<ButtonSpacing, string> = {
  compact: 'py-3 px-6',
  normal: 'py-4 px-6',
  default: 'py-3 px-3',
};

export const Button = (props: ButtonProps) => {
  const {
    className,
    disabled,
    children,
    variant,
    roleButton,
    ariaLabel,
    href,
    target,
    spacing = 'default',
    ...otherProps
  } = props;
  const padding = SPACING_CONFIG[spacing];

  const mods: Mods = {
    [`cursor-pointer rounded-xl ${disabled ? 'bg-custom-surface-contrast-low text-text-base-tertiary' : 'bg-custom-base-inverse-primary text-custom-base-primary hover:bg-custom-base-inverse-secondary'} ${padding} font-medium`]:
      variant === 'primary',
    [`cursor-pointer rounded-xl ${disabled ? 'bg-custom-surface-contrast-low text-text-base-tertiary' : 'bg-custom-surface-contrast-low text-text-base-primary hover:bg-custom-surface-contrast-mid'} ${padding} font-medium`]:
      variant === 'secondary',
    ['cursor-pointer rounded-xl font-medium ${padding} hover:text-text-base-secondary']:
      variant === 'tertiary',
    [`cursor-pointer rounded-xl font-medium ${padding} ${disabled ? 'bg-custom-surface-contrast-low text-text-base-tertiary' : 'bg-surface-base-inverse-primary2 text-text-base-inverse-primary hover:bg-surface-base-inverse-secondary'}`]:
      variant === 'fourth',
  };

  if (href) {
    return (
      <Link
        href={href}
        target={target}
        rel="noopener noreferrer"
        className={classNames({
          cls: 'flex transition-colors duration-300',
          mods,
          additional: [className],
        })}
        onClick={otherProps.onClick}
        style={otherProps.style}
      >
        {children}
      </Link>
    );
  }

  return (
    <button
      className={classNames({
        cls: 'flex transition-colors duration-300',
        mods,
        additional: [className],
      })}
      type="button"
      role={roleButton || 'button'}
      disabled={disabled}
      aria-label={ariaLabel || 'button'}
      {...otherProps}
    >
      {children}
    </button>
  );
};
